module.exports = __webpack_public_path__ + "img/文心.7806f441.png";